import { FileReader, FileWriter } from '@/platform'
import AvgButton from '../ComControl/AvgButton'

class BtnList {
    /**
     * 按钮集合
     */
    public buttons: AvgButton[] = [new AvgButton()]
    readBin(reader: FileReader): void {
        this.buttons = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let avgButton = new AvgButton()
            avgButton.readBin(reader)
            this.buttons.push(avgButton)
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.buttons.length)
        for (let i = 0; i < this.buttons.length; i++) {
            const btn = this.buttons[i]
            btn?.writeBin(writer)
        }
    }

    readVersionedOui(reader: FileReader): void {
        this.buttons = []
        const len = reader.readInt()
        for (var i = 0; i < len; i++) {
            let avgButton = new AvgButton()
            avgButton.readVersionedOui(reader.readObj(reader.readInt()))
            this.buttons.push(avgButton)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.buttons.length)
        for (let i = 0; i < this.buttons.length; i++) {
            const btn = this.buttons[i]
            btn.writeVersionedOui(writer)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        writer.writeInt(this.buttons.length)
        for (let i = 0; i < this.buttons.length; i++) {
            this.buttons[i]?.writeVersionedOui(writer)
        }
    }
}
export default BtnList
